<div class="row" *ngIf="isBasica || isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <!--FIRST ROW COLUMN-->
                    <div class="row pt-3">
                        <div class="col-lg-2 col-md-9 col-xs-6 col-sm-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Recebimento</mat-label>
                                <mat-select #txtSiteRecebimento formControlName="Site_recebimento"
                                    disableCenteringOption disabled class="InputBlockColor">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterSiteRecebimento($event.target.value)">
                                    <mat-option *ngFor="let item of listSiteRecebimento" [value]="item.initials">
                                        {{item.initials | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Site_recebimento)}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-2 col-md-9 col-xs-6 col-sm-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra</mat-label>
                                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="Safra" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtSafra.value.length}} / 8</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Safra)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-2 col-md-9 col-xs-6 col-sm-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Híbrido RNC / Linhagem</mat-label>
                                <input matInput id="txtHibrido" #txtHibrido maxlength="40" formControlName="Hibrido_rnc"
                                    class="InputBlockColor" readonly>
                                <!-- <mat-autocomplete #auto5="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredOptionsHibrido | async" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtHibrido.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Hibrido_rnc)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-2 col-md-9 col-xs-3 col-sm-3">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data de Despalha</mat-label>
                                <input matInput id="txtDataDespalha" #txtDataDespalha maxlength="10" mask="d0/M0/0000"
                                    formControlName="Data_despalha">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataDespalha.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Data_despalha)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-2 col-md-9 col-xs-4 col-sm-4">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Cerar<span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtCerar" #txtCerar maxlength="17" formControlName="Cerar"
                                    (blur)="getDataFromCerar()" (blur)="checkCerarExist()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtCerar.value.length}} / 17</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Cerar)}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-1 col-md-3 col-xs-3 col-sm-3 btnAlignSelf">
                            <button mat-flat-button class="btnsize" color="primary" matTooltip="Leitor Cerar"
                                id="btnCerar" name="btnCerar" (click)="openDialog()" [disabled]="disableBtnCerar">
                                <i class="{{iconBarCodeField}}"></i> Leitor Cerar
                            </button>
                        </div>
                    </div>

                    <!--SECOND ROW COLUMN-->
                    <div class="row pt-3">
                        <div class="col-lg col-md-9 col-xs-6 col-sm-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Gleba</mat-label>
                                <input matInput id="txtGleba" #txtGleba maxlength="80" formControlName="Gleba" readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtGleba.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Gleba)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Contrato Jurídico</mat-label>
                                <input matInput id="txtContratoJuridico" #txtContratoJuridico maxlength="40"
                                    formControlName="Contrato_juridico" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtContratoJuridico.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Contrato_juridico)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">N° de campo (Básica)</mat-label>
                                <input matInput id="txtNumCampo" #txtNumCampo maxlength="20" [readonly]="true"
                                    formControlName="Nr_campo" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtNumCampo.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Nr_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso líquido da carga Cooperante (kg)</mat-label>
                                <input matInput id="txtPeso_liq_carga_cooperante_kg" #txtPeso_liq_carga_cooperante_kg
                                    maxlength="10" formControlName="Peso_liq_carga_cooperante_kg" currencyMask
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_liq_carga_cooperante_kg.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_liq_carga_cooperante_kg)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso da amostra Cooperante (g)</mat-label>
                                <input matInput id="txtPeso_amostra_cooperante_g" #txtPeso_amostra_cooperante_g
                                    maxlength="10" formControlName="Peso_amostra_cooperante_g" currencyMask
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_amostra_cooperante_g.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_amostra_cooperante_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso da palha Cooperante (g)</mat-label>
                                <input matInput id="txtPeso_palha_cooperante_g" #txtPeso_palha_cooperante_g
                                    maxlength="10" formControlName="Peso_palha_cooperante_g" currencyMask
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_palha_cooperante_g.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_palha_cooperante_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso da impureza Cooperante (g)</mat-label>
                                <input matInput id="txtPeso_impureza_cooperante_g" #txtPeso_impureza_cooperante_g
                                    maxlength="10" formControlName="Peso_impureza_cooperante_g" currencyMask
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_impureza_cooperante_g.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_impureza_cooperante_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso do sabugo Cooperante (g)</mat-label>
                                <input matInput id="txtPeso_sabugo_cooperante_g" #txtPeso_sabugo_cooperante_g
                                    maxlength="10" formControlName="Peso_sabugo_cooperante_g" currencyMask
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_sabugo_cooperante_g.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_sabugo_cooperante_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso da semente Cooperante (g)</mat-label>
                                <input matInput id="txtPeso_semente_cooperante_g" #txtPeso_semente_cooperante_g
                                    maxlength="10" formControlName="Peso_semente_cooperante_g" currencyMask
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtPeso_semente_cooperante_g.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_semente_cooperante_g)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade (%)</mat-label>
                                <input matInput id="txtUmidade" #txtUmidade maxlength="10" formControlName="Umidade"
                                    currencyMask class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtUmidade.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">

                        <div class="col-lg col-md"></div>
                        <div class="col-lg col-md"></div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>

<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <!--FIRST ROW COLUMN-->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Recebimento
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSiteOrigem" #txtSiteOrigem maxlength="20" readonly
                                    formControlName="site_recebimento" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.site_recebimento)}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">{{hintSafraPreBasicaLabel}}
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtSafraBasica" class="text-uppercase" txtSafraBasica maxlength="5"
                                    (blur)="changeSafra($event)" formControlName="safra_basica">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.safra_basica)}}</mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Cerar (Básica)<span
                                        class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtCerarBasica" #txtCerarBasica maxlength="10"
                                    formControlName="cerar_basica" (blur)="changeSafra($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtCerarBasica.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.cerar_basica)}}</mat-error>
                            </mat-form-field>
                        </div>


                    </div>

                    <!--SECOND ROW COLUMN-->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número do Campo (Básica)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtNumCampo" #txtNumCampo maxlength="20" appOnlyNumberVirgula
                                    formControlName="numero_campo" (blur)="changeSafra($event)">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtNumCampo.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.numero_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Gleba
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtGleba" #txtGleba maxlength="1" formControlName="gleba"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.gleba)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Geração
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtGeracao" #txtGeracao maxlength="20" readonly
                                    formControlName="geracao" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.geracao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Nota de ardida
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtNotaArdida" #txtNotaArdida maxlength="20" readonly
                                    formControlName="nota_ardida" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.nota_ardida)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número da Caixa
                                    <span class="InputRequired">{{required}}</span></mat-label>

                                <mat-select formControlName="numero_caixa" disableOptionCentering
                                    (selectionChange)="changeCaixa($event)">
                                    <mat-option *ngFor="let item of listNumeroCaixa" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <!-- <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint> -->
                                <mat-error>{{hasErrorFormControl(formulario.controls.numero_caixa)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Houve troca de caixa?
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <mat-select formControlName="houve_troca_caixa" disableOptionCentering
                                    (selectionChange)="onChangeNovaCaixa($event)">
                                    <mat-option *ngFor="let item of listHouveTrocaCaixa" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número novo de caixa</mat-label>
                                <input matInput id="txtNovoNumeroCaixa" #txtNovoNumeroCaixa maxlength="5"
                                    formControlName="novo_numero_caixa" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }" [readonly]="!isNovaCaixa"
                                    [class.InputBlockColor]="!isNovaCaixa">
                                <i *ngIf="!isNovaCaixa" matSuffix class="{{iconDisableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.novo_numero_caixa )}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Controle de Caixa
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput #txtControleCaixa maxlength="5" formControlName="controle_caixa"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote Rw - Exemplo: E1DGRAO001
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtLoteRw" #txtLoteRw maxlength="10" formControlName="lote_rw"
                                    class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintLoteDsPet}}</mat-hint>
                                <mat-hint align="end">{{txtLoteRw.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_rw)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <!--  novo campo Manufatura/linhagem -->
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Manufatura/linhagem
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtManufatura" #txtManufatura maxlength="80" [readonly]="true"
                                    formControlName="hibrido_rnc" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hibrido_rnc)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo Colheita
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtTipoColheita" #txtTipoColheita maxlength="10"
                                    formControlName="tipo_colheita" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tipo_colheita)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Contrato Jurídico
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtContratoCampo" #txtContratoCampo maxlength="100"
                                    formControlName="contrato_juridico" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.contrato_juridico)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-sm">
                            <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Origem
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtSiteOrigem" #txtSiteOrigem maxlength="20" readonly
                                    formControlName="site_origem" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.site_origem)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Nota de granação</mat-label>
                                <input matInput id="txtNotaGranacao" #txtNotaGranacao maxlength="10"
                                    formControlName="nota_granacao" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.nota_granacao )}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso RW (kg)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPesoRw" #txtPesoRw maxlength="10" formControlName="peso_rw"
                                    readonly class="InputBlockColor" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.peso_rw)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Peso Pós Secagem (Kg)
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtPesoPosSecagem" #txtPesoPosSecagem
                                    formControlName="peso_pos_secagem" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" class="InputBlockColor"
                                    readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>